import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { IFilterServiceDto } from 'src/app/models/Ifilter-service-dto';
import { IService } from 'src/app/models/iservice';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  dir:string;
  filterService:any="";
  instructionService:any = "";
  services:IService[];
  @Output() closeServiceDlgEvent = new EventEmitter<boolean>();
  _loadAllData:boolean = false;
  @Input() set loadAllData(value:boolean){
    this._loadAllData = value;
    if(value == true){
      this.loadServicesData();
    }
  }
  constructor(private helperService:HttphelperService,private translate: TranslateService,public breadSer:BreadcrumbService,private messageService: MessageService) { 
    let currentLnaguage =  localStorage.getItem('lang');
    if(currentLnaguage == null){
        this.dir = "ltr"; 
    }
    else
    {
      if(currentLnaguage == 'ar'){
        this.dir = "rtl"; 
      }
      else{
        this.dir = "ltr"; 
      }
    }
  }

  ngOnInit(): void {
  }
  loadServicesData(){
    let filter :IFilterServiceDto  =  
    {
      ProviderId : this.breadSer.callQueue.ProviderID,
      ClinicId : this.breadSer.callQueue.ClinicID,
      ClinicTypeId : this.breadSer.clinicTypeId,
      IsTelemedVisit : this.breadSer.addtionalData.istele,
      IsHomeVisit : this.breadSer.addtionalData.ishome,
      IsClinicVisit : this.breadSer.addtionalData.isclinic,
      RequestType : 0,
      Name:this.filterService
    };
    this.services = [];
    var url = `/api/Queue/GetServices`;
    this.helperService.postRequest(url,true,filter).subscribe(response =>
    {
      if(response.Success)
      {
        this.services = response?.Data;
        if(this.services == null || this.services == undefined)
        {
          this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
        }
      }
      else
      {
        this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
      }   
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
    })
  }
  openService(e:any){
    var id = this.services[e.index].id;
    this.instructionService = "";
    var url = `/api/Queue/GetServiceInstructions/${id}`;
    this.helperService.getRequest(url).subscribe(response =>
    {
      this.instructionService = response;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
    })
  }
  onChangeService(){
    this.loadServicesData();
  }
  selectService(service:IService){
    this.breadSer.callQueue.ServiceId = service.id;
    this.breadSer.callQueue.ServiceName = service.text;
    this.breadSer.price = service.Price;
    this.closeServiceDlgEvent.emit(false);
  }
}
